import classNames from "classnames";
import PropTypes from "prop-types";
import { BiCog } from "react-icons/bi";
import CanvasIcon from "./CanvasIcon";
import { ICON_PATHS } from "./step-look";

export const SIDE_PANELS = {
  LUCIE: "lucie",
  SETTINGS: "settings",
};

const SideRail = ({ open, labels, onToggle }) => {
  const item = (panel, label, icon) => (
    <button
      type="button"
      className={classNames("canvas-rail__button", {
        "canvas-rail__button--active": open === panel,
      })}
      aria-label={label}
      title={label}
      aria-expanded={open === panel}
      onClick={() => onToggle(panel)}
    >
      {icon}
    </button>
  );
  return (
    <nav className="canvas-rail" aria-label={labels.RAIL}>
      {item(
        SIDE_PANELS.LUCIE,
        labels.LUCIE,
        <CanvasIcon path={ICON_PATHS.quote} size={18} strokeWidth={2} />,
      )}
      {item(SIDE_PANELS.SETTINGS, labels.SETTINGS, <BiCog size={20} />)}
    </nav>
  );
};

SideRail.propTypes = {
  open: PropTypes.string,
  labels: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};

SideRail.defaultProps = {
  open: null,
};

export default SideRail;
